import { BiEditAlt } from 'react-icons/bi';
import { editablePostionFields } from './consts';

const checkIsEditable = (fieldName: string) => editablePostionFields.includes(fieldName);

export const getEditIcon = (fieldName: string, onEdit: () => void) => {
    return checkIsEditable(fieldName) && <BiEditAlt onClick={onEdit} />;
};
